module.exports = (__parcel__import__("./" + "Native.11e3f97e.js")).then(() => parcelRequire('dqcZH'));